import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dateColumn, emailColumn } from '~/modules/common/data-table/columns';
import type { ColumnOrColumnGroup } from '~/modules/common/data-table/types';
import { ResendPendingInvitationCell } from '~/modules/memberships/pending-table/resend-pending-cell';
import type { PendingMembership } from '~/modules/memberships/types';
import { UserCell } from '~/modules/user/user-cell';

/** `canResend`: the viewer holds `update` on the channel, which a resend needs. */
export const useColumns = (path: { tenantId: string; organizationId: string }, canResend: boolean) => {
  const { t } = useTranslation();

  const columns: ColumnOrColumnGroup<PendingMembership>[] = [
    emailColumn({ name: t('c:email') }),
    {
      key: 'role',
      name: t('c:role'),

      width: 100,
      placeholderValue: '-',
      renderCell: ({ row }) => (row.role ? <div className="group relative inline-flex size-full items-center gap-1">{t(row.role)}</div> : null),
    },
    dateColumn('createdAt', { name: t('c:invited_at') }),
    {
      key: 'createdBy',
      name: t('c:invited_by'),

      minBreakpoint: 'md',
      minWidth: 160,
      placeholderValue: '-',
      renderCell: ({ row, tabIndex }) => row.createdBy && <UserCell compactable user={row.createdBy} tabIndex={tabIndex} />,
    },
  ];

  if (canResend) {
    columns.push({
      key: 'resend',
      name: '',
      width: 120,
      placeholderValue: '-',
      renderCell: ({ row }) => <ResendPendingInvitationCell {...path} membershipId={row.id} />,
    });
  }

  return useState<ColumnOrColumnGroup<PendingMembership>[]>(columns);
};
